/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfListOfOperationalLinkTypeDto } from "../models/AjaxResponseOfListOfOperationalLinkTypeDto";
import type { AjaxResponseOfOperationalLinkTypeDto } from "../models/AjaxResponseOfOperationalLinkTypeDto";
import type { CreateOrUpdateOperationalLinkTypeDto } from "../models/CreateOrUpdateOperationalLinkTypeDto";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class OperationalLinkTypesAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfListOfOperationalLinkTypeDto Success
   * @throws ApiError
   */
  public getAll({
    targetScope,
  }: {
    targetScope?: string;
  }): CancelablePromise<AjaxResponseOfListOfOperationalLinkTypeDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/operational/link-types",
      query: {
        targetScope: targetScope,
      },
    });
  }
  /**
   * @returns AjaxResponseOfOperationalLinkTypeDto Success
   * @throws ApiError
   */
  public create({
    requestBody,
  }: {
    requestBody?: CreateOrUpdateOperationalLinkTypeDto;
  }): CancelablePromise<AjaxResponseOfOperationalLinkTypeDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/operational/link-types",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({
    linkTypeId,
  }: {
    linkTypeId: number;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/operational/link-types/{linkTypeId}",
      path: {
        linkTypeId: linkTypeId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfOperationalLinkTypeDto Success
   * @throws ApiError
   */
  public update({
    linkTypeId,
    requestBody,
  }: {
    linkTypeId: number;
    requestBody?: CreateOrUpdateOperationalLinkTypeDto;
  }): CancelablePromise<AjaxResponseOfOperationalLinkTypeDto> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/operational/link-types/{linkTypeId}",
      path: {
        linkTypeId: linkTypeId,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
}
